import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import SubNavLink from './SubNavLink'

const LinksContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  font-size: 20px;
  color: #56565A;
  font-family: 'Open Sans';
  line-height: 28px;
  align-items: center;
  height: 40px;
`
const Divider = styled.div`
  font-size: 20px;
  font-weight: 600;
  margin: 0px 5px;
`


const SubNav = ({ leftLink, rightLink }) => {
  return (
    <LinksContainer>
      <SubNavLink link={leftLink} />
      <Divider>
        |
      </Divider>
      <SubNavLink link={rightLink} />
    </LinksContainer>
  )
}

SubNav.propTypes = {
  leftLink: PropTypes.shape({
    href: PropTypes.string,
    title: PropTypes.string
  }),
  rightLink: PropTypes.shape({
    href: PropTypes.string,
    title: PropTypes.string
  })
}

export default SubNav
